import { Lightbulb } from "lucide-react";

 const NoDataPlaceholder = () => (
    <div className="flex flex-col justify-center items-center p-8 text-muted-foreground text-center">
        <Lightbulb className="mb-2 w-8 h-8" />
        <h3 className="mb-1 font-semibold text-lg">No Data Yet</h3>
        <p className="text-sm">
            Start adding entries to see your progress over time
        </p>
    </div>
);

export default NoDataPlaceholder;